"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Permissions {
}
exports.Permissions = Permissions;
//# sourceMappingURL=Permissions.js.map